import React, { useContext, useEffect, useState } from "react";
import { StyleSheet, ScrollView, View, Image, Dimensions, Pressable } from "react-native";
import { FindifyTopBarOverlay } from "../genericPages/components/FindifyTopBarOverlay";
import { BasePage } from "../genericPages/helpers/BasePage";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { FindifySimpleHeader, SimpleHeaderAction } from "../genericPages/components/FindifySimpleHeader";
import { FindifyHTMLRender } from "../genericPages/helpers/FindifyHTMLRender";
import { PlaceText } from "../genericPages/components/PlaceText";
import { useTranslation } from "react-i18next";
import { BottomNavigationPadding } from "../genericPages/components/FindifyNavigation";
import { FindifyLoadingScreen } from "../genericPages/components/FindifyLoadingScreen";
import { IconShadow } from "../genericPages/helpers/DefaultShadows";
import { ContentDetailsType, MakeContentDetailsSetActions, PlaceContentDetailsInitialUseEffect } from "@/layouts/genericPages/helpers/DetailsHelpers";
import { ContentDetailsGallery } from "@/layouts/genericPages/components/ContentDetailsGallery";
import { makeContentDetails } from "../genericPages/PlaceContentDetails";

export const PlaceContentDetailsTab = ({ navigation, ...props }: any) => {
    const [contentModule, setContentModule] = useState<any>();
    const [contentSlug, setContentSlug] = useState<any>();
    const [hideDate, setHideDate] = useState(false);
    const { t } = useTranslation();
    const [content, setContent] = useState<any>();
    const findifyDataContext = useContext(FindifyDataContext);

    useEffect(() => {
        PlaceContentDetailsInitialUseEffect(props, findifyDataContext, setContent, setContentSlug, setContentModule, setHideDate);
    }, [])


    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        {content &&
            <ScrollView
                bounces={false}
                showsHorizontalScrollIndicator={false}
                showsVerticalScrollIndicator={false}
                style={[styles.container, { backgroundColor: PlaceColors(findifyDataContext).background.get() }]}>
                {makeContentDetails(MakeContentDetailsPage, content, t, hideDate, contentModule, navigation, findifyDataContext)}
            </ScrollView>
        }
        {!content && <FindifyLoadingScreen />}
    </BasePage>;
};



const MakeContentDetailsPage = ({ image, title, navigation, resume, description, dateString, rightActions, content, t, hideDate, module, findifyDataContext }: ContentDetailsType) => {
    const topTextStyle = {
        marginTop: 5,
        fontSize: 14,
        color: PlaceColors(findifyDataContext).text.withAlpha(160)
    };
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);
    const [renderImageSize, setRenderImageSize] = useState<any>({});
    const [textSizeModifier, setTextSizeModifier] = useState<number>(0);

    useEffect(() => {
        if (image) {
            Image.getSize(image, (width, height) => {
                const imgSizeObj = { width, height };
                setRenderImageSize({
                    width: (Dimensions.get('window').width - 40),
                    height: ((Dimensions.get('window').width - 40) / imgSizeObj.width) * imgSizeObj.height,
                    borderRadius: 16,
                })
            }, () => {});
        }
    }, [image]);

    useEffect(() => {
        MakeContentDetailsSetActions(setActionsList, title, findifyDataContext, content, module);
    }, [module])

    return <>
        <FindifySimpleHeader navigation={navigation}
            title={title}
            actions={actionsList}
            image={image}
        />
        <View style={[{
            backgroundColor: PlaceColors(findifyDataContext).background.get(),
            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
            marginTop: -24,
            padding: 20,
            paddingBottom: 20 + BottomNavigationPadding,
        }]}>
            <View style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 15,
            }}>
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                    {!hideDate &&
                        <PlaceText style={{
                            fontSize: 14,
                            color: PlaceColors(findifyDataContext).text.withAlpha(200),
                            fontWeight: '500',
                        }}>{dateString}</PlaceText>
                    }
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: PlaceColors(findifyDataContext).primary.withAlpha(20), borderRadius: 20, paddingHorizontal: 8, paddingVertical: 4 }}>
                        <Pressable onPress={() => setTextSizeModifier(prev => Math.max(prev - 2, -4))} style={{ paddingHorizontal: 8 }}>
                            <PlaceText style={{ fontSize: 16, fontWeight: 'bold', color: PlaceColors(findifyDataContext).primary.get() }}>A-</PlaceText>
                        </Pressable>
                        <View style={{ width: 1, height: 16, backgroundColor: PlaceColors(findifyDataContext).primary.withAlpha(50) }} />
                        <Pressable onPress={() => setTextSizeModifier(prev => Math.min(prev + 2, 8))} style={{ paddingHorizontal: 8 }}>
                            <PlaceText style={{ fontSize: 18, fontWeight: 'bold', color: PlaceColors(findifyDataContext).primary.get() }}>A+</PlaceText>
                        </Pressable>
                    </View>
                    {rightActions}
                </View>
            </View>
            
            {/* address / resume */}
            {!!resume && <PlaceText style={[topTextStyle, { fontSize: 15 + (textSizeModifier * 0.5), marginBottom: 15, fontWeight: '600', color: PlaceColors(findifyDataContext).text.get() }]}>{resume}</PlaceText>}

            <FindifyHTMLRender
                baseStyles={{
                    color: PlaceColors(findifyDataContext).text.get(),
                    fontSize: 16 + textSizeModifier,
                    lineHeight: (16 + textSizeModifier) * 1.5,
                }}
                htmlCode={description} />

            {content.galleries && <View style={{ marginTop: 20 }}><ContentDetailsGallery findifyDataContext={findifyDataContext} t={t} content={content} navigation={navigation} /></View>}
        </View >
    </>
}

const styles = StyleSheet.create({
    text: {
        padding: 10,
        paddingBottom: 10 + BottomNavigationPadding,
    },
    container: {
        height: '100%',
        width: '100%',
    },

    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
})
